import React from "react";

type MainContentLayoutProps = React.ClassAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement> & {
  homeLayout?: boolean;
}

export default function MainContentLayout({ children, homeLayout, className, ...props }: MainContentLayoutProps) {
  return (
    <div className={`!mt-20 ${!homeLayout && 'md:!mt-12'} mainLayout pb-20  ${className}`} {...props}>
      {children}


    </div>
  )
}